import { useTranslation } from 'react-i18next';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

export default function TryAndBuyAuth() {
  const { t, i18n } = useTranslation();
  const {lang} = useParams()
  const [notify, setNotify] = useState(false)
  const [message, setMessage] = useState('')
  const [tracking, setTracking] = useState('');
  const isArabic = i18n.language === 'ar' || lang === 'ar';

  useEffect(() => {
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  const trackOrder = () => {
    const shipmentNumber = tracking.trim();

    if (!shipmentNumber) {
      setMessage(t('Please enter the shipment number'));
      setNotify(true);
      return;
    }

    setNotify(false);
    const phoneNumber = (process.env.REACT_APP_TRY_AND_BUY_WHATSAPP_NUMBER || '').replace(/\D/g, '');
    const whatsappMessage = process.env.REACT_APP_TRY_AND_BUY_WHATSAPP_MESSAGE || '';
    const message = encodeURIComponent(`${whatsappMessage}\n${shipmentNumber}`);
    window.location.href = `https://wa.me/${phoneNumber}?text=${message}`;
  }

  return (
    <main className={`${isArabic ? 'rtl' : 'ltr'} min-h-dvh bg-white sm:px-5 sm:py-3 text-darkblue`}>
      <section className="text-center relative mx-auto flex sm:min-h-[calc(100dvh-24px)] min-h-dvh sm:max-w-sm w-full flex-col overflow-hidden sm:rounded-[34px] sm:border-[3px] border-coconut-white bg-white shadow-[0_22px_55px_rgba(10,50,102,0.08)]">
        <div className="relative z-10 flex flex-1 flex-col px-6 pb-28 pt-14">
          <img
            className="mx-auto mb-8 h-auto w-[162px]"
            src="https://production-publicstorage1123538a-1j4jxuuq2c9nf.s3.eu-west-3.amazonaws.com/customer-portal/logo.png"
            alt="ShipBlu Logo"
          />

          <h1 className="mb-4 text-xl font-bold leading-8">
            {t('ShipBlu Try & Buy Service')}
          </h1>
          <p className="mb-4 font-semibold text-berwick-berry">
            {t('Welcome')}
          </p>
          <p className="mb-8 text-sm font-medium text-berwick-berry">
            {t('Please enter the shipment number to continue')}
          </p>

          <div className="mx-auto w-full max-w-xs text-start">
            <label className="mb-2 block text-sm font-bold text-sambucus" htmlFor="try-and-buy-tracking">
              {t('Shipment number')}
            </label>
            <input
              id="try-and-buy-tracking"
              className="h-[42px] w-full rounded-md border border-morning-chill bg-white px-3 font-medium text-funnel-cloud outline-none transition placeholder:text-silverware focus:border-y7k-blue focus:ring-2 focus:ring-arc-light text-start"
              value={tracking}
              onChange={(e) => setTracking(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter")
                  trackOrder();
              }}
              type="text"
              placeholder={t('Tracking Number')}
            />

            {notify &&
              <p className="mt-1 text-xs font-semibold text-red-600">
                {message}
              </p>
            }

            <button
              className="mt-6 flex h-11 w-full items-center justify-center gap-2 rounded-md bg-bright-blue px-4 font-bold text-white shadow-[0_6px_14px_rgba(0,95,255,0.25)] transition hover:bg-frosted-blueberries focus:outline-none focus:ring-2 focus:ring-arc-light focus:ring-offset-2"
              onClick={trackOrder}
              type="button"
            >
              <WhatsAppIcon sx={{ fontSize: 24 }} />
              <span>{t('Get order details!')}</span>
            </button>

            <p className="mt-4 text-center text-xs font-medium text-berwick-berry">
              {t('WhatsApp will open to send a message')}
            </p>
          </div>
        </div>

        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-24 overflow-hidden">
          <div className="absolute -bottom-9 -left-10 h-24 sm:w-[230px] w-[253px] rounded-[50%] bg-calcareous-sinter opacity-90"></div>
          <div className="absolute -bottom-11 right-[-36px] h-32 sm:w-[260px] w-[286px] rotate-[-12deg] rounded-[50%] bg-icy-plains opacity-85"></div>
          <div className="absolute -bottom-10 left-[50px] h-24 sm:w-[250px] w-[275px] rotate-[10deg] rounded-[50%] bg-white opacity-70"></div>
        </div>
      </section>
    </main>
  )
}
